import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

interface Member {
  community_member_id: number;
  messaging_enabled: boolean;
}

export const useMessageActions = () => {
  const { currentCommunityMember } = usePunditUserContext();

  const shouldShowRemoveOption = (member: Member) => {
    const isCurrentCommunityMemberProfile =
      currentCommunityMember?.id === member.community_member_id;
    return !isCurrentCommunityMemberProfile && currentCommunityMember?.is_admin;
  };

  return { shouldShowRemoveOption };
};
